import moment from 'moment';
import { DateModelOptions } from '../options/date-model-options';
import { TimeModelOptions } from '../options/time-model-options';
import { DateModel } from '../primitive/date.model';
import { TimeModel } from '../primitive/time.model';
import { CompositeModel } from './composite.model';
import { getNextTimesheetEntryCounter } from './timesheet-entry-counter';
import { TimesheetEntryInterface } from './timesheet-entry.interface';

export class TimesheetGapModel extends CompositeModel implements TimesheetEntryInterface {
    public startDate: DateModel;
    public startTime: TimeModel;
    public endDate: DateModel;
    public endTime: TimeModel;

    public readonly index: number;
    public constructor(
        startDateTime: moment.Moment,
        endDateTime: moment.Moment,
        public mandatory = true,
    ) {
        super('TimesheetGapModel');

        this.index = getNextTimesheetEntryCounter();

        const clonedStart = startDateTime.clone();
        const clonedEnd = endDateTime.clone();

        this.startDate = new DateModel('StartDate', clonedStart, new DateModelOptions({ readonly: true }));
        this.startTime = new TimeModel('StartTime', clonedStart, new TimeModelOptions({ readonly: true }));
        this.endDate = new DateModel('EndDate', clonedEnd, new DateModelOptions({ readonly: false }));
        this.endTime = new TimeModel('EndTime', clonedEnd, new TimeModelOptions({ readonly: false }));
    }

    public toJSON(): unknown {
        return {
            startDateTime: this.startDate.value,
            endDateTime: this.endDate.value,
        };
    }
}

export class TimesheetGapModelFromJson extends TimesheetGapModel {
    public constructor(data: JsonTimesheetGapModel) {
        super(
            data.startDateTime ? moment(data.startDateTime) : moment.invalid(),
            data.endDateTime ? moment(data.endDateTime) : moment.invalid(),
        );
    }
}

export interface JsonTimesheetGapModel {
    startDateTime: string;
    endDateTime: string;
}
